/**
 * External dependencies.
 */
import classnames from "classnames";

/**
 * WordPress dependencies.
 */
import { __, sprintf } from "@wordpress/i18n";

const NAVIGATION_ITEMS = [
  {
    slug: "welcome",
    label: __("Welcome", "ultrablocks"),
    visibility: false,
  },
  {
    slug: "blocks",
    label: __("Blocks", "ultrablocks"),
    visibility: true,
  },
  {
    slug: "integrations",
    label: __("Integrations", "ultrablocks"),
    visibility: true,
  },
  {
    slug: "upsell",
    label: __("Free vs PRO", "ultrablocks"),
    visibility: false,
    // visibility: !Boolean(window.ultrablocksObj.hasPro),
  },
  {
    slug: "feedback",
    label: __("Feedback", "ultrablocks"),
    visibility: false,
  },
];

const {ultrablocksAdminObj} = window;

const Headers = ({ isActive, setActive }) => {
  return (
    <div className="ultrablocks-navigation">
      <div className="ultrablocks-navigation-left">
        <img
          src={window.ultrablocksAdminObj.assetsUrl + "images/admin-logo.png"}
          title={__(
            "Ultrablocks – Page Builder Blocks & Extensions for Gutenberg",
            "ultrablocks"
          )}
        />
      </div>
      <nav className="ultrablocks-navigation-center">
        {NAVIGATION_ITEMS.map(
          (item) =>
            item.visibility && (
              <a
                className={classnames({
                  "is-active": item.slug === (isActive || "blocks"),
                })}
                onClick={() => setActive(item.slug)}
                key={item.slug}
              >
                <span>{item.label}</span>
              </a>
            )
        )}
      </nav>
      <div className="ultrablocks-navigation-right">
        <abbr
          title={sprintf(
            __("Version: %s", "ultrablocks"),
            ultrablocksAdminObj.version
          )}
          className="version"
        >
          {__("Version", "ultrablocks")}: {ultrablocksAdminObj.version}
        </abbr>
      </div>
    </div>
  );
};

export default Headers;
